// extracted by mini-css-extract-plugin
export var MsoFootnoteReference = "tags-module--MsoFootnoteReference--b301f";
export var MsoFootnoteText = "tags-module--MsoFootnoteText--5b886";
export var activeTag = "tags-module--activeTag--c13f2";
export var deleteButton = "tags-module--deleteButton--129c5";
export var inactiveTag = "tags-module--inactiveTag--af8ad";
export var inlineGatsbyImageWrapper = "tags-module--inline-gatsby-image-wrapper--f8b7f";
export var lintonInfo = "tags-module--lintonInfo--06d44";
export var tagListWrapper = "tags-module--tagListWrapper--877ce";
export var wpCaption = "tags-module--wp-caption--8b135";